import { HttpErrorResponse } from '@angular/common/http';

import { Action } from '@ngrx/store';

import { IMemberProfilePaymentCard } from '@shared/shared/interfaces/member-profile-payment-card.interfaces';

// Create payment card
export const CREATE_PROFILE_PAYMENT_CARD = '[Member Profile] Create Profile Payment Card';
export const CREATE_PROFILE_PAYMENT_CARD_SUCCESS = '[Member Profile] Create Profile Payment Card Success';
export const CREATE_PROFILE_PAYMENT_CARD_FAIL = '[Member Profile] Create Profile Payment Card Fail';

export class CreateProfilePaymentCard implements Action {
  readonly type = CREATE_PROFILE_PAYMENT_CARD;
  constructor(public payload: IMemberProfilePaymentCard) {}
}

export class CreateProfilePaymentCardSuccess implements Action {
  readonly type = CREATE_PROFILE_PAYMENT_CARD_SUCCESS;
  constructor(public payload: IMemberProfilePaymentCard) {}
}

export class CreateProfilePaymentCardFail implements Action {
  readonly type = CREATE_PROFILE_PAYMENT_CARD_FAIL;
}

// Destroy payment card
export const DESTROY_PROFILE_PAYMENT_CARD = '[Member Profile] Destroy Profile Payment Card';
export const DESTROY_PROFILE_PAYMENT_CARD_SUCCESS = '[Member Profile] Destroy Profile Payment Card Success';
export const DESTROY_PROFILE_PAYMENT_CARD_FAIL = '[Member Profile] Destroy Profile Payment Card Fail';

export class DestroyProfilePaymentCard implements Action {
  readonly type = DESTROY_PROFILE_PAYMENT_CARD;
  constructor(public payload: number) {}
}

export class DestroyProfilePaymentCardSuccess implements Action {
  readonly type = DESTROY_PROFILE_PAYMENT_CARD_SUCCESS;
  constructor(public payload: number) {}
}

export class DestroyProfilePaymentCardFail implements Action {
  readonly type = DESTROY_PROFILE_PAYMENT_CARD_FAIL;
  constructor(public error: HttpErrorResponse) {}
}

// Update payment card
export const UPDATE_PROFILE_PAYMENT_CARD = '[Member Profile] Update Profile Payment Card';
export const UPDATE_PROFILE_PAYMENT_CARD_SUCCESS = '[Member Profile] Update Profile Payment Card Success';
export const UPDATE_PROFILE_PAYMENT_CARD_FAIL = '[Member Profile] Update Profile Payment Card Fail';

export class UpdateProfilePaymentCard implements Action {
  readonly type = UPDATE_PROFILE_PAYMENT_CARD;
  constructor(public payload: { data: Partial<IMemberProfilePaymentCard>; id: number; defaultCardChange?: boolean }) {}
}

export class UpdateProfilePaymentCardSuccess implements Action {
  readonly type = UPDATE_PROFILE_PAYMENT_CARD_SUCCESS;
  constructor(public payload: IMemberProfilePaymentCard) {}
}

export class UpdateProfilePaymentCardFail implements Action {
  readonly type = UPDATE_PROFILE_PAYMENT_CARD_FAIL;
}

// Get payment cards
export const GET_PROFILE_PAYMENT_CARDS = '[Member Profile] Get Profile Payment Cards';
export const GET_PROFILE_PAYMENT_CARDS_SUCCESS = '[Member Profile] Get Profile Payment Cards Success';
export const GET_PROFILE_PAYMENT_CARDS_FAIL = '[Member Profile] Get Profile Payment Cards Fail';

export class GetProfilePaymentCards implements Action {
  readonly type = GET_PROFILE_PAYMENT_CARDS;
}

export class GetProfilePaymentCardsSuccess implements Action {
  readonly type = GET_PROFILE_PAYMENT_CARDS_SUCCESS;
  constructor(public paymentCards: IMemberProfilePaymentCard[]) {}
}

export class GetProfilePaymentCardsFail implements Action {
  readonly type = GET_PROFILE_PAYMENT_CARDS_FAIL;
  constructor(public error: HttpErrorResponse) {}
}

export type MemberProfilePaymentCardAction =
  | GetProfilePaymentCards
  | GetProfilePaymentCardsSuccess
  | GetProfilePaymentCardsFail
  | CreateProfilePaymentCard
  | CreateProfilePaymentCardSuccess
  | CreateProfilePaymentCardFail
  | DestroyProfilePaymentCard
  | DestroyProfilePaymentCardSuccess
  | DestroyProfilePaymentCardFail
  | UpdateProfilePaymentCard
  | UpdateProfilePaymentCardSuccess
  | UpdateProfilePaymentCardFail;
